import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  Renderer2,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ViConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ViConfirmObject } from './confirm.model';

@Directive({
  selector: '[viConfirm]',
  standalone: true,
})
export class ViConfirmDirective implements OnDestroy, OnChanges {
  private confirmDialogRef: MatDialogRef<ViConfirmDialogComponent>;

  @Input('viConfirm') data: ViConfirmObject;

  @Output() confirm: EventEmitter<void> = new EventEmitter<void>();

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('click')
  onClick(): void {
    this.openDialog();
  }

  constructor(private matDialog: MatDialog, private renderer: Renderer2) {}

  ngOnChanges(): void {
    if (this.data && !this.data.hasOwnProperty('displayDialog')) {
      this.data.displayDialog = true;
    }
  }

  ngOnDestroy(): void {
    this.renderer.destroy();
  }

  private openDialog(): void {
    if (this.data.displayDialog) {
      this.confirmDialogRef = this.matDialog.open(ViConfirmDialogComponent, {
        width: '480px',
        panelClass: 'confirm-dialog',
        disableClose: true,
        autoFocus: false,
        restoreFocus: false,
        data: this.data,
      });
      this.handleDialogClose();
    }
  }

  private handleDialogClose(): void {
    this.confirmDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.confirm.emit();
      } else {
        this.cancel.emit();
      }
    });
  }
}
